function describedByIds(element: Element): string[] {
    return element.getAttribute('aria-describedby')?.split(/\s+/).filter(Boolean) ?? [];
}

/** Appends `id` to the element's `aria-describedby`; returns `false` when it was already there. */
export function addDescribedBy(element: Element, id: string): boolean {
    const ids = describedByIds(element);
    if (ids.includes(id)) return false;

    element.setAttribute('aria-describedby', [...ids, id].join(' '));
    return true;
}

/** Removes `id` from the element's `aria-describedby`, keeping the descriptions set by others. */
export function removeDescribedBy(element: Element, id: string): void {
    const ids = describedByIds(element).filter((describedById) => describedById !== id);

    if (ids.length) {
        element.setAttribute('aria-describedby', ids.join(' '));
    } else {
        element.removeAttribute('aria-describedby');
    }
}
